import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { withRouter } from 'react-router-dom';
import M from 'materialize-css/dist/js/materialize';
import { translate, enumText, showMessageToastCustom } from '../../../../utils/util';
import { Breadcrumbs, Button, Input, ListPagination, Modal } from '../../../../components/UI/ComponentsUI';
import { onValueChange, validateInputsRequired } from '../../../../utils/handleChangeHooks';
import { ENUMS } from '../../../../utils/constants';
import PickingService from '../../../../services/PickingService';

const TDReport = (props) => {
    const [selectedOrder, setSelectedOrder] = useState();
    const [openModal, setOpenModal] = useState(false);
    const [currentPage, setCurrentPage] = useState(0);
    const [instanceM, setInstanceM] = useState();
    const [data, setData] = useState([]);
    const [filter, setFilter] = useState({
            status: [
                ENUMS.eOrderStatus.Waiting.value,
                ENUMS.eOrderStatus.InProgress.value, 
                ENUMS.eOrderStatus.WaitingRouteComposition.value, 
                ENUMS.eOrderStatus.WaitingRouteInformation.value
            ],
            orderType: ENUMS.eOrderType.LinePicking.value,
            orderCode: undefined,
            partnumber: undefined
        });

    useEffect(() => {
        if (props.orders?.items?.length > 0) {
            if (data.length > 0 && currentPage === 0) {
                setData(props.orders.items);
            } else {
                setData((prevState) => ([...prevState, ...props.orders.items]));
            }
        } else {
            setData([]);
        }
        // eslint-disable-next-line
    }, [props.orders?.items]);

    useEffect(() => {
        if (currentPage > 0) {
            onFilter();
        }
        // eslint-disable-next-line
    }, [currentPage]);

    useEffect(() => {
        const instance = M.Collapsible.init(document.querySelectorAll('.collapsible'), {
            accordion: false
        });
        setInstanceM(instance);
        return () => {
            setData([]);
        }
        // eslint-disable-next-line
    }, []);

    const doWriteOff = () => {
        if (props.orders?.items?.length > 0) {
            let order = selectedOrder;
            props.writeOffOrder(order.orderCode, (response) => {
                showMessageToastCustom(translate('general.info'), translate('messages.write-off-success', 'line-picking'), 1000, 'mdi mdi-checkbox-marked-circle-outline green-text');
                onFilter(true);
            });
        }
    }

    const onFilter = (click) => {
        var currentPageList = currentPage;
        if (validateInputsRequired("formsReport")) {
            if (click) {
                currentPageList = 0;
                setCurrentPage(0);
                setData([]);
            }
            props.getOrders(filter, {
                PageSize: 25,
                PageIndex: currentPageList
            }, () => {
                instanceM[1].close();
            });
        }
    }

    const onChange = (event) => {
        onValueChange(event, filter, setFilter);
    };

    const getStatus = (value) => translate(`expedition:${enumText(ENUMS.eOrderStatus, value)}`);

    const renderItem = (item, index) => {
        return (
            <div key={index}>
                <span
                    className="title sixth-text-color right"
                    style={{ position: 'absolute', marginTop: '0px', right: '10px', zIndex: '999' }}
                >
                    <i 
                        className={`mdi mdi-36px mdi-archive-check-outline`} 
                        onClick={() => { 
                            setSelectedOrder(item);
                            setOpenModal(true)
                        }} 
                        
                    />
                </span>
                <div
                    style={{ display: 'block', padding: '10px', height: 'auto' }}
                >
                    <div className="row" style={{ marginBottom: '0px' }}>
                        {
                            item?.orderCode &&
                            <div className="col s12" style={{ color: 'black' }}> {item?.orderCode} </div>
                        }
                    </div>
                    <div className="row" style={{ marginBottom: '0px' }}>
                        <div className="col s12">
                            <label>{` ${translate('general:status')}: ${(item.status) ? getStatus(item.status) : 'N/A'}`}</label>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    return (
        <div>
            <Breadcrumbs id="reportTitle" title={{ icon: "mdi mdi-archive-clock-outline", label: translate('expedition:picking.openTds') }} />
            <div className="container-fluid" style={{ marginTop: '20px' }}>
                <div className="container" style={{ marginTop: '0px' }}>
                    <ul id='collapsible' className="collapsible">
                        <li className='active'>
                            <div className="collapsible-header">
                                {translate('expedition:picking.filter')}
                            </div>
                            <div className="collapsible-body" style={{ padding: '10px' }}>
                                <div id="formsReport" className="row">
                                    <div className="input-field no-padding col s12">
                                        <Input
                                            defaultValue={filter.orderCode}
                                            id="orderCode"
                                            name='orderCode'
                                            label='TD'
                                            type="text"
                                            onChange={onChange}
                                        />
                                    </div>
                                    <div className="input-field no-padding col s12">
                                        <Input
                                            defaultValue={filter.partnumber}
                                            id="partnumber"
                                            name='partnumber'
                                            label={translate('expedition:picking.partnumber')}
                                            type="text"
                                            onChange={onChange}
                                        />
                                    </div>
                                </div>
                                <div className="row" style={{ paddingTop: '5px' }}>
                                    <Button onClick={() => onFilter(true)} full="true" text={translate('delivery:general.search')} />
                                </div>
                            </div>
                        </li>
                    </ul>
                </div>
                <div id="list">
                    <ListPagination
                        disableRow={true}
                        page={props.orders?.totalPages}
                        current={{ currentPage, setCurrentPage }}
                        data={
                            data.map((item, index) => {
                                return renderItem(item, index);
                            })
                        }
                    />
                </div>
            </div>
            <Modal
                open={openModal}
                id="ModalTDWriteOff"
                content={translate('linepicking.do-td-write-off', 'line-picking')}
                dismissible={false}
                onConfirm={() => {
                    doWriteOff()
                    setOpenModal(false);
                }}
                onCancel={() => setOpenModal(false)}
                closeModal={() => setOpenModal(false)}
                btnCancel={translate("general:cancel")}
                btnConfirm={translate("general:confirm")}
            />
        </div>
    );
}

const getListSelectUser = (usersElog) => {
    let users = [];
    usersElog.forEach(item => {
        users.push({
            id: item.userName,
            user: item.userName,
        });
    });

    usersElog.forEach(item => {
        users.push({
            id: item.userName,
            user: item.name,
        });
    });

    return users;
}

const mapStateToProps = (state) => {
    return {
        usersFromElog: getListSelectUser(state.usersElogReducer.usersElog),
        orders: state.pickingReducer.orders
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getOrders: (filter, pagination, callback) => {
            dispatch(PickingService.getOrders(filter, pagination, callback));
        },
        writeOffOrder: (orderCode, callback) => {
            dispatch(PickingService.writeOffOrder(orderCode, callback));
        }
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withTranslation()(TDReport)));
